const toDateOnly = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

const asArray = (value) => (Array.isArray(value) ? value : []);


const readAssigneeId = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'object') {
    const nestedId = value.id ?? value.userId ?? value.contractorId ?? value.globalContractorId;
    const parsedNested = Number(nestedId);
    return Number.isFinite(parsedNested) ? parsedNested : null;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const getRecordId = (record) => String(record?.id ?? record?.workOrderId ?? record?.formId ?? '');

const getStatusLabel = (record) => {
  if (record?.status?.name) return record.status.name;
  if (record?.workOrderStatus?.name) return record.workOrderStatus.name;
  if (record?.notificationStatus?.name) return record.notificationStatus.name;
  return record?.status || 'Open';
};

const getPriority = (record) => record?.priority?.name || record?.priority || record?.priorityId;

const getAreaName = (record) => record?.area?.name || record?.areaName || '';

const getAssetName = (record) => {
  if (record?.asset?.assetDescription) return record.asset.assetDescription;
  if (record?.asset?.assetNumber) return record.asset.assetNumber;
  return record?.assetName || '';
};

export const normaliseAssignments = ({ workOrders = [], forms = [], crewById = {}, contractorById = {} }) => {
  const workOrderEvents = asArray(workOrders)
    .map((workOrder) => {
      const date = toDateOnly(workOrder?.scheduledAt || workOrder?.dueDate);
      if (!date) return null;

      const crewAssignees = asArray(workOrder?.crew)
        .map((userRef) => {
          const userId = readAssigneeId(userRef);
          if (!Number.isFinite(userId)) return null;
          return {
            id: userId,
            type: 'internal',
            name: crewById?.[userId]?.name || crewById?.[String(userId)]?.name || `User ${userId}`,
          };
        })
        .filter(Boolean);

      const contractorAssignees = asArray(workOrder?.contractors)
        .map((contractorRef) => {
          const contractorId = readAssigneeId(contractorRef);
          if (!Number.isFinite(contractorId)) return null;
          return {
            id: contractorId,
            type: 'contractor',
            name: contractorById?.[contractorId]?.name || contractorById?.[String(contractorId)]?.name || `Contractor ${contractorId}`,
          };
        })
        .filter(Boolean);

      return {
        id: `wo-${getRecordId(workOrder)}`,
        kind: 'workOrder',
        title: workOrder?.workOrderTitle || workOrder?.title || `Work Order #${workOrder?.workOrderNumber || getRecordId(workOrder)}`,
        date,
        status: getStatusLabel(workOrder),
        priority: getPriority(workOrder),
        areaName: getAreaName(workOrder),
        assetName: getAssetName(workOrder),
        assignees: [...crewAssignees, ...contractorAssignees],
        linkStatus: workOrder?.linkStatus || undefined,
        original: workOrder,
      };
    })
    .filter(Boolean);

    

  const formEvents = asArray(forms)
    .map((form) => {
     
      const date = toDateOnly(form?.scheduledAt || form?.assignedAt);
      if (!date) return null;

      const assignees = [];
      if (form?.assignUserId) {
        const assigneeId = form?.assignUserId;
        assignees.push({
          id: assigneeId,
          type: 'internal',
          name: crewById?.[assigneeId]?.name || `User ${assigneeId}`,
        });
      }

      if (form?.assignedContractorId) {
        const contractorId = form?.assignedContractorId;
        assignees.push({
          id: contractorId,
          type: 'contractor',
          name: contractorById?.[contractorId]?.name || `Contractor ${contractorId}`,
        });
      }

      

      return {
        id: `form-${getRecordId(form)}`,
        kind: 'form',
        title: `FO-${String(getRecordId(form)).padStart(8, '0')}`,
        date,
        status: getStatusLabel(form),
        priority: getPriority(form),
        areaName: getAreaName(form),
        assetName: getAssetName(form),
        assignees,
        linkStatus: form?.linkStatus || undefined,
        original: form,
      };
    })
    .filter(Boolean);

  return [...workOrderEvents, ...formEvents];
};

export default normaliseAssignments;
